(function() {
    $('.project-shots__image').unveil(200, function() {
        $(this).on('load', function() {
            let loader = this.parentNode.parentNode.getElementsByClassName('loader-cube')[0]

            this.parentNode.classList.add('project-shots__wrap--is-loaded')

            if (loader) {
                this.parentNode.parentNode.removeChild(loader)
            }
        })
    })
})()